module.exports = __webpack_public_path__ + "img/upload-primary.7004d2dc.svg";